import { Box, Card, CardContent, Grid2, Typography } from "@mui/material"
import './reports.css'
import { useNavigate } from "react-router-dom"

const Reports = () => {
    const navigate = useNavigate()

    return (
        <Box className='container' sx={{height: '100vh'}}>
            <Typography className="title">Reports</Typography>

            <Grid2 container sx={{marginTop: '30px'}}>
                <Grid2 item sx={{display: 'flex', gap: '40px'}}>
                    <Card className="card" onClick={() => navigate('performanceTracker')}>
                        <CardContent className="cardContent">
                            <Typography className="cardTitle">Recruiter Performance Tracker</Typography>
                        </CardContent>
                    </Card>

                    <Card className="card" onClick={() => navigate('manageEventsReport')}>
                        <CardContent className="cardContent">
                            <Typography className="cardTitle">Manage Events Status Report</Typography>
                        </CardContent>
                    </Card>

                    <Card className="card" onClick={() => navigate('clientHiringReport')}>
                        <CardContent className="cardContent">
                            <Typography className="cardTitle">Client Hiring Summary Report</Typography>
                        </CardContent>
                    </Card>
                </Grid2>
            </Grid2>
        </Box>
    )
}

export default Reports